import defaults from './default.service';

export const featuresService = {
  get,
  update,
  all,
};

function get(id) {
  const requestOptions = {
    ...defaults.defaultRequestOptions('GET'),
  };

  return defaults.defaultFetch({
    url: `/admin/features/${id}`,
    requestOptions,
  });
}

function update(form) {
  const { settings, id } = form;

  const requestOptions = {
    ...defaults.defaultRequestOptions('POST'),
    body: JSON.stringify(settings),
  };

  return defaults.defaultFetch({
    url: `/admin/features/${id}`,
    requestOptions,
  });
}

function all(_no, _no1, _no2) {
  const requestOptions = {
    ...defaults.defaultRequestOptions('GET'),
  };
  return defaults.defaultFetch({ url: `/admin/features`, requestOptions });
}
